import type { ChangeEvent } from 'react'
import { useCallback } from 'react'
import { SwitchBase } from '@instacart/ids-tooling'
import { Accordion, Text } from '@retailer-platform/shared-components'
import { useDashMessages } from '../../../../intl/intl.hooks'
import { useAdminControls } from '../../../../utils/contexts/admin-controls/AdminControlsContext'

export const UseTdsNav = () => {
  const { useTdsNav, setAdminControl } = useAdminControls()
  const handleSwitchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setAdminControl('useTdsNav', event.target.checked)
    },
    [setAdminControl]
  )

  const i18n = useDashMessages({
    useTdsNavTitle: 'app.admin.controlPanel.setting.useTdsNav.title',
    useTdsNavDesc: 'app.admin.controlPanel.setting.useTdsNav.description',
  })

  const title = (
    <div css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {i18n.useTdsNavTitle}

      <div css={{ flex: 1 }} />

      <div css={{ overflow: 'hidden' }}>
        <SwitchBase
          name="useTdsNavSwitch"
          id="useTdsNavSwitch"
          checked={useTdsNav}
          onClick={evt => evt.stopPropagation()}
          onChange={handleSwitchChange}
        />
      </div>
    </div>
  )

  return (
    <Accordion showContentBackground={true} title={title}>
      <Text size="small">{i18n.useTdsNavDesc}</Text>
    </Accordion>
  )
}
